import React from 'react'
import Grid from '@mui/material/Grid'
import { NavLink, Redirect, Route } from 'react-router-dom'
import LoginComponent from '../../components/auth/LoginComponent'

const AuthPage: React.FC = () => {
  /* 828
  const history = useHistory()

  const goTo = (location: string): void => {
    history.push(location)
  }

  const loginSession: AuthSession = AuthService.getLoginSession()
  if (loginSession.isLoggedIn) {
    goTo('/app/dashboard')
  }
  */

  return (
    <>

      <Grid container justifyContent={'center'} alignItems={'center'}>
        <Grid item lg={4}>
          <div className="brand-logo pb-4 text-center">
            <NavLink to={'/'} className="logo-link">
              <img className="logo-img logo-img-lg" src="/logo.png" alt="logo" />
            </NavLink>
          </div>
          <Redirect exact to={'/auth/login'} from={'/auth'} />
          <Route exact={true} path={'/auth/login'}>
            <LoginComponent />
          </Route>
        </Grid>
      </Grid>
    </>
  )
}

export default AuthPage
